// extracted by mini-css-extract-plugin
module.exports = {"progressBarContainer":"ExamHistoryTable_progressBarContainer__3HlAh","progressBar":"ExamHistoryTable_progressBar__fjNUf","isExamPassed":"ExamHistoryTable_isExamPassed__3Ctn9"};